import { type QueryHookOptions, useQuery } from "@apollo/client";
import { SubscriptionsListQuery } from "../graphql/queries";
import type {
  SubscriptionsListQueryType,
  SubscriptionsListQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useSubscriptionsQuery = (
  options?: QueryHookOptions<
    SubscriptionsListQueryType,
    SubscriptionsListQueryVariablesType
  >
) => {
  return useQuery<
    SubscriptionsListQueryType,
    SubscriptionsListQueryVariablesType
  >(SubscriptionsListQuery, options);
};
